module.exports = __webpack_public_path__ + "img/logoEn.e414be57.png";